import type { SlopeKeycloak } from '../core/index.js';

/**
 * Get authentication token for GraphQL requests
 * @param keycloak - SlopeKeycloak instance
 * @returns Promise<string> - The authentication token
 */
export async function getToken(keycloak: SlopeKeycloak): Promise<string> {
  const { token } = await keycloak.getToken();
  return token;
}

/**
 * Create authorization header for GraphQL requests
 * @param keycloak - SlopeKeycloak instance
 * @returns Promise<string> - Authorization header value
 */
export async function getAuthHeader(keycloak: SlopeKeycloak): Promise<string> {
  const token = await getToken(keycloak);
  return `Bearer ${token}`;
}

/**
 * Create headers object for GraphQL requests
 * @param keycloak - SlopeKeycloak instance
 * @returns Promise<{Authorization: string}> - Headers object
 */
export async function getAuthHeaders(keycloak: SlopeKeycloak): Promise<{ Authorization: string }> {
  const authHeader = await getAuthHeader(keycloak);
  return {
    Authorization: authHeader,
  };
}
